import { twMerge } from 'tailwind-merge';

type Props = {
  className?: string;
  children: React.ReactNode;
};

const ContentWrapper = ({ children, className = '' }: Props) => {
  return (
    <div className={twMerge('sm:px-8 sm-max:px-4 mx-auto max-w-screen-xl', className)}>
      {children}
    </div>
  );
};

export default ContentWrapper;
